// Mirror of the server's MEAL_TYPES (server/storage.py): Dinner or Other
// for now. A list of strings so more types can be added later without a
// migration. Keep this in sync with storage.py when the list grows.
export const MEAL_TYPES = ["Dinner", "Other"]